import React from 'react';
import { AdminPanel } from './pages/admin/AdminPanel';
import { LoginPage } from './pages/LoginPage';
import { ModulesPage } from './pages/ModulesPage';
import { useAuth } from './contexts/AuthContext';
import { Toaster } from 'react-hot-toast';

function App() {
  const { user, isLoading } = useAuth();
  const path = window.location.pathname;

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  // Route handling
  if (path === '/login') {
    // Redirect to admin if already logged in
    if (user) {
      window.location.replace('/admin');
      return null;
    }
    return (
      <>
        <LoginPage />
        <Toaster position="top-right" />
      </>
    );
  }

  // Handle admin routes
  if (path.startsWith('/admin')) {
    // Redirect to login if not authenticated
    if (!user) {
      const returnUrl = encodeURIComponent(path);
      window.location.replace(`/login?returnTo=${returnUrl}`);
      return null;
    }

    return (
      <>
        <AdminPanel />
        <Toaster position="top-right" />
      </>
    );
  }

  // For all other routes, show modules page
  return (
    <>
      <ModulesPage />
      <Toaster position="top-right" />
    </>
  );
}

export default App;